const config = {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  REACT_APP_TMDB_API_READING_KEY: process.env.REACT_APP_TMDB_API_READING_KEY,
  REACT_APP_TMDB_API_KEY: process.env.REACT_APP_TMDB_API_KEY
};

export default config;